<div class="login">
  <h1 class="visually-hidden">Login</h1>
  <div class="login__card">
    <img class="login__card__logo" [src]="client.getInvertedLogoURL()" [alt]="client.getSiteName()">

    <h2 class="login__card__heading"
    [innerText]="'Welcome to Your Total Rewards Statement' | translate"></h2>

    <p class="login__card__subheading"
      [innerText]="'View a personalized statement of your total benefits, rewards and compensation.' |translate">
    </p>

    <form [formGroup]="loginForm" novalidate>

      @if (errorMessage) {
        <div class="login__card__error">
          <h4 class="login__card__error__heading">Login Failed</h4>
          <span [innerHTML]="errorMessage"></span>
        </div>
      }

      <a [class.spinner]="loading" class="btn--clean-green" href="/sso/">
        <core-spinner name="login"></core-spinner>
        @if (!loading) {
          <span [innerText]="'Login' | translate"></span>
        }
        @if (loading) {
          <span [innerText]="'Logging in...' | translate"></span>
        }

        <img alt="" src="/assets/img/icons/right-arrow-icon.svg" />
      </a>

      <div class="login__card__caption">
        <img alt="Note:" src="assets/img/icons/info-icon.svg" />
        <span class="login__card__caption__body">If you are logged into the SOLV Energy network, you
          may click login and be connected
        via single sign-on above.</span>
      </div>

      <div class="login__card__help">
        <h3 class="login__card__help__heading" [innerText]="'Need help?' | translate"></h3>
        <span class="login__card__help__body">If you need help logging in, please contact your SOLV
          HR Team at <a href="mailto:benefits@solvenergy.com">benefits&#64;solvenergy.com</a></span>
        </div>

      </form>
    </div>

    <div class="login__footer">
    <span [innerHTML]="'&copy; ' + currentYear +
        ' Gallagher | All Rights Reserved.' + ' Powered by Core.'"></span>
    </div>
  </div>
